import { Component, OnInit } from '@angular/core';

import { PreaggregationStrategy } from '../../shared/preaggregation/preaggregation-strategy';
import { AggregationSevice } from 'src/app/shared/preaggregation/aggregation-service';
import { ProjectService } from 'src/app/shared/project/project.service';
import { MatDialog } from '@angular/material/dialog';
import { ChangesModalComponent } from './changes-modal.component';
import { ImportStep } from '../import-step';
import { BaseImportStepComponent, ImportStepState } from '../base-import-step.component';
import { AggregationType } from 'src/app/shared/preaggregation/aggregation-method';
import { Router } from '@angular/router';

@Component({
    selector: 'preaggregation-strategy',
    templateUrl: './preaggregation-strategy.component.html',
    styleUrls: ['../general.scss', '../column-types/column-selection.scss']
})
export class PreaggregationStrategySelectComponent extends BaseImportStepComponent implements OnInit {
    readonly step = ImportStep.PreaggregationStrategy;
    PreaggregationStrategy: typeof PreaggregationStrategy = PreaggregationStrategy;   //hack for enum to be available in the template
    projectId: string;
    availableStrategies: PreaggregationStrategy[] = [];
    selectedStrategy: PreaggregationStrategy;

    outcomeColumnName: string;
    volumeFormulaComponetColumnName: string;
    formulaComponentsNames: string;
    oldControlColumnValue: string;
    newControlColumnValue: string;

    public numOfCombinations: number;
    public numOfDimensions: number;
    public dimensionsNames: string;
    public numOfNotUniqueCombinations: number;
    public percOfNotUniqueCombinations: number;
    public numOfBothControlValuesCombinations: number;
    public percOfBothControlValuesCombinations: number;

    public weightColumnName: string;
    public weightedColumnNames: string;
    public summedColumnNames: string;
    public averagedColumnNames: string;

    loading = false;
    dataLoaded = false;
    selectingWeightColumn = false;
    selectingColumnsToSum = false;

    constructor(private preaggregationSevice: AggregationSevice, private router: Router, projectService: ProjectService, public dialog: MatDialog)  {
        super(projectService);
    }

    public async loadDataInternal(): Promise<void> {
        const result = await this.preaggregationSevice.getPreaggregationStrategyModel(this.projectId);
        this.stepState = result.stepState;

        if (result.stepState === ImportStepState.NotAvailableYet || result.stepState === ImportStepState.NotAvailableForProject) {
            return;
        }

        this.selectedStrategy = result.selectedStrategy;
        this.outcomeColumnName = result.outcomeColumnName;
        this.oldControlColumnValue = result.oldControlColumnValue;
        this.newControlColumnValue = result.newControlColumnValue;
        this.availableStrategies = result.availablePreaggregationStrategies;

        this.numOfCombinations = result.numOfCombinations;
        this.numOfDimensions = result.numOfDimensions;
        this.dimensionsNames = result.dimensionsNames;
        this.numOfNotUniqueCombinations = result.numOfNotUniqueCombinations;
        this.percOfNotUniqueCombinations = result.percOfNotUniqueCombinations;
        this.numOfBothControlValuesCombinations = result.numOfBothControlValuesCombinations;
        this.percOfBothControlValuesCombinations = result.percOfBothControlValuesCombinations;
        this.formulaComponentsNames = result.formComps.map(fc => fc.name).join(", ");
        this.summedColumnNames = result.formComps.filter(fc => fc.aggregationMethod.type === AggregationType.sum).map(c => c.name).join(', ');
        this.averagedColumnNames = result.formComps.filter(fc => fc.aggregationMethod.type !== AggregationType.sum).map(c => c.name).join(', ');

        this.loadTexts();

        this.dataLoaded = true;
    }

    async selectStrategy() {
        if (this.loading) {
            return;
        }
        try {
            this.loading = true;
            if (this.selectedStrategy == PreaggregationStrategy.reselectDimensions) {
                this.router.navigateByUrl(`/import-wizard?projectId=${this.projectId}&step=Dimensions`);
                return;
            } else if (this.selectedStrategy == PreaggregationStrategy.reuploadFile) {
                this.router.navigateByUrl('/projects?reuploadProjectId=' + this.projectId);
                return;
            }
            const changesApplied = await this.preaggregationSevice.savePreaggregationStrategy(this.projectId, this.selectedStrategy);
            this.finishStepSuccessfully(changesApplied);
        } finally {
            this.loading = false;
        }
    }

    public radioChange($event) {
        this.loadTexts();
    }

    public startSelectingWeightColumn() {
        this.selectingWeightColumn = true;
        this.selectingColumnsToSum = false;
    }

    public startSelectingColumnsToSum() {
        this.selectingWeightColumn = false;
        this.selectingColumnsToSum = true;
    }

    private loadTexts() {
       /* if (this.columns && this.columns.length) {
            let weightColumn = this.columns.find(c => c.isSelected);
            this.weightColumnName = weightColumn ? '[' + weightColumn.name + ']' : undefined;
            this.weightedColumnNames = this.columns.filter(c => ! c.isSelected && c.type == ColumnType.formulaComponent) .map(c => '[' + c.name + ']').join(', ');
            this.summedColumnNames = this.columns.filter(c => c.isSelectedAlt).map(c => '[' + c.name + ']').join(', ');
            this.averagedColumnNames = this.columns.filter(c => !c.isSelectedAlt && c.type == ColumnType.formulaComponent) .map(c => '[' + c.name + ']').join(', ');
        }*/
    }

    showChangesDialog() {
        const dialogRef = this.dialog.open(ChangesModalComponent, {
            data: {
                testData: { num: 9, str: 'data2'} ,
            },
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log(`Dialog result: ${result}`);
        });
    }
}
